import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import SEO from '../components/SEO';

// 2025 Client Testimonials (YouTube)
const testimonials2025 = [
  { id: 'j4pm85lpUNg', name: 'Millennium Al Rawdah Hotel', location: 'Abu Dhabi', platform: 'youtube' },
  { id: 'DkppMObe7YQ', name: 'LEO & LOONA KIDS PARK', location: 'Dubai, UAE', platform: 'youtube' },
  { id: 'hxdDkPv9x4U', name: 'Tang Palace Hotel', location: 'Ghana', platform: 'youtube' },
  { id: 'EwhaZm-54fE', name: 'Ethno Village Dolene', location: 'Bulgaria', platform: 'youtube' },
  { id: '4sxGAD7_7oY', name: 'Kihaa Maldives', location: 'Maldives', platform: 'youtube' },
  { id: 'hxl-6HDG8Ek', name: 'The Noverian Scenic Crete 5*, Hilltop Villa Resort & Spa', location: 'Tbilisi, Georgia', platform: 'youtube' },
  { id: 'Pl680A7n4jI', name: 'Ethno Village Dolene', location: 'Dolene, Petroch, Bulgaria', platform: 'youtube' },
  { id: 'Yx9PBj4BMuE', name: 'Flytop Aviation Limited', location: 'Hong Kong', platform: 'youtube' },
];

// 2024 Client Testimonials
const testimonials2024 = [
  { id: '1053370400', name: 'Dr. Mary Jane Alvero-Al Mahdi' },
  { id: '1053370512', name: 'Eman Talal AlAskandrani' },
  { id: '1053370602', name: 'Farid Dallal' },
  { id: '1053369561', name: 'Full Circle Co.LLC' },
  { id: '1053369666', name: 'Glenn Perry' },
  { id: '1053369784', name: 'Ichiryu Ramen House' },
  { id: '1053369902', name: 'Jomav Homes & Properties Ltd' },
  { id: '1053369990', name: 'Kawther Haciane' },
  { id: '1053370178', name: 'Riversong Technology' },
  { id: '1053370101', name: 'Little Diamond Nursery' },
];

// 2023 Client Testimonials
const testimonials2023 = [
  { id: '916292410', name: 'Aji Creative' },
  { id: '916292513', name: 'AlRedha Insurance Brokers LLC' },
  { id: '916292921', name: 'Arabica Orient Tours' },
  { id: '916292963', name: 'Ayaan Ali' },
  { id: '916292993', name: 'BA CONSULTING RH' },
  { id: '916293028', name: 'Basil Konfor' },
  { id: '916293070', name: 'BITS Pilani, Dubai Campus' },
  { id: '916293127', name: 'Cybercenter' },
  { id: '916293162', name: 'Desert Flower Tours' },
  { id: '916293194', name: 'Dr Imad Syed' },
  { id: '916293232', name: "Dr Indira Naidoo's Early Learning Academy" },
  { id: '916293262', name: 'EDEN AESTHETICS Clinic' },
  { id: '916293291', name: 'Emad Ramzy' },
  { id: '916293392', name: 'Enver Arslan' },
  { id: '916292654', name: 'Food Nation Catering' },
  { id: '916292712', name: 'Guac Digital INC' },
  { id: '916292750', name: 'Gurnoor Bindra' },
  { id: '916292805', name: 'MOHAMMED IQBAL' },
  { id: '916292837', name: 'Mosaic Dance And Music Institute' },
  { id: '916292355', name: 'Volga International Equipment Trading LLC' },
  { id: '916292897', name: 'ZEE TRAVELS LTD' },
];

// International Travel / Spa / Dining / GM Awards 2023
const testimonials2023Awards = [
  { id: '841092971', name: 'Aqeel Ahmed Abbasi' },
  { id: '841093455', name: 'Azimut Tour Operator & DMC' },
  { id: '854974515', name: 'Castle IN LOVE WITH THE WIND' },
  { id: '854975051', name: 'Centara Mirage Beach Resort Dubai' },
  { id: '854975515', name: 'Chamisse Restaurant' },
  { id: '854975869', name: 'Conrad Dubai' },
  { id: '854973960', name: 'Damir Kartal' },
  { id: '841091642', name: 'DISCOVER AFRICA TRAVEL' },
  { id: '841093611', name: 'Dzimbahwe Guest Lodge' },
  { id: '841093191', name: 'ELENA ORRU' },
  { id: '863043889', name: 'Firas Al Alami' },
  { id: '841092421', name: 'Gromaxx Hotels Management LLC' },
  { id: '863044847', name: 'Heart And Soul Spa' },
  { id: '841094290', name: 'Heavens Beauty And Spa' },
  { id: '863045182', name: 'Hills And Hues' },
  { id: '863044223', name: 'Hilton London Metropole' },
  { id: '841094804', name: 'Krishan Kodippili' },
  { id: '863045432', name: 'La Perla SPA' },
  { id: '841094021', name: 'LILLEHAMMER SPA AS' },
  { id: '841091849', name: 'Maps & Vogs Holidays' },
  { id: '863045857', name: 'Mostafa Hawwas' },
  { id: '841092787', name: 'Mrad El Khoury' },
  { id: '863046167', name: 'Nadia Nassar' },
  { id: '841092582', name: 'Omar Bouchaar' },
  { id: '841092049', name: 'PALBINA TRAVEL LTD' },
  { id: '863047804', name: 'Paya Bunga Hotel Terengganu' },
  { id: '863046832', name: "Pierre's TT" },
  { id: '863047146', name: 'Qasr Al Watan' },
  { id: '841093804', name: 'RAF Hotel Apartments LLC' },
  { id: '855002526', name: 'Saad Khayat' },
  { id: '841093307', name: 'Samer Homsi' },
  { id: '855003288', name: 'Sophie Blondel' },
  { id: '841100786', name: 'SWAHILI BEACH' },
  { id: '855000518', name: 'Tang Palace Hotel' },
  { id: '841098755', name: 'The Grand Palace Suites - Hotel' },
  { id: '855001642', name: 'The Granite Luxury Hotel' },
  { id: '855000096', name: 'The S Holiday Homes' },
];

// Arabian Best of Best Awards 2022
const testimonials2022 = [
  { id: '788891524', name: 'KONOZ RETAJ EVENTS', location: 'Riyadh, Saudi Arabia' },
  { id: '788891243', name: 'Alliance Traffic Systems', location: 'United Arab Emirates' },
  { id: '788891760', name: 'Middle East Building Security L.L.C', location: 'United Arab Emirates' },
  { id: '788891433', name: 'Dar Al Yaqut Property Management', location: 'United Arab Emirates' },
  { id: '788891874', name: 'Techbot Information Technology LLC', location: 'United Arab Emirates' },
  { id: '788891838', name: 'Spades Real Estate Brokers', location: 'United Arab Emirates' },
  { id: '788891792', name: 'Premier Insurance Brokers L.L.C', location: 'United Arab Emirates' },
  { id: '788891475', name: 'Fidelity Insurance Services LLC', location: 'United Arab Emirates' },
  { id: '788891575', name: 'Maharat Learning Center', location: 'Saudi Arabia' },
  { id: '788891367', name: 'CTC HOUSE AND HOME REAL ESTATE', location: 'United Arab Emirates' },
  { id: '788891314', name: 'Aries Marine Co. WLL', location: 'Qatar' },
  { id: '788891150', name: '66 Real Estate LLC', location: 'United Arab Emirates' },
];

// International Travel Awards 2021
const testimonials2021 = [
  { id: '792516185', name: 'Kalldeen Luxury Accommodation' },
  { id: '792516139', name: 'ALHIND TOURS AND TRAVELS' },
  { id: '792515080', name: 'Vivanta, Kathmandu' },
  { id: '792515032', name: 'Ultimate Driving Club' },
  { id: '792514976', name: 'The Avenue, A Murwab Hotel' },
  { id: '792514768', name: 'Ponha Aqui O Seu Pezinho' },
  { id: '792514272', name: 'Boulevard9 Luxury Resort & Spa' },
  { id: '792514214', name: 'Zeldiva Luxury' },
  { id: '792514171', name: 'Valencia Travel' },
  { id: '792514124', name: 'Deluxe Holiday Homes' },
  { id: '792514014', name: 'Crown Hotel Port Moresby' },
  { id: '792513429', name: 'Vegan Travel Asia By VegVoyages' },
  { id: '792513375', name: 'The Ritz-Carlton, Doha' },
  { id: '792513178', name: 'Riali Consult Ltd' },
  { id: '792513123', name: 'Radisson Blu Hotel Yerevan' },
  { id: '792513080', name: 'Maison Prive Holiday Homes Rental LLC' },
  { id: '792512983', name: 'CASTLE IN LOVE WITH THE WIND' },
  { id: '792512908', name: 'BOTANIQ Castle Of Tura' },
  { id: '792512849', name: 'Art Palace Of Georgia - Museum Of Cultural History' },
  { id: '792512455', name: 'Address Beach Resort' },
];

const VideoCard = ({ video }) => {
  // Determine embed URL based on platform (YouTube or Vimeo)
  const embedUrl = video.platform === 'youtube'
    ? `https://www.youtube.com/embed/${video.id}?rel=0`
    : `https://player.vimeo.com/video/${video.id}?badge=0&autopause=0&player_id=0&app_id=58479`;

  return (
    <div className="group">
      <div className="relative aspect-video bg-black rounded-lg overflow-hidden mb-3">
        <iframe
          src={embedUrl}
          title={video.name}
          className="w-full h-full"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
          allowFullScreen
        />
      </div>
      <h4 className="font-montserrat text-white text-sm font-medium">{video.name}</h4>
      {video.location && (
        <p className="font-google-sans text-[#A1A1AA] text-xs mt-1">{video.location}</p>
      )}
    </div>
  );
};

const TestimonialSection = ({ title, videos }) => (
  <div className="mb-16">
    <h2 className="font-montserrat text-2xl sm:text-3xl text-white mb-8">
      {title}
    </h2>
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
      {videos.map((video) => (
        <VideoCard key={video.id} video={video} />
      ))}
    </div>
  </div>
);

export const TestimonialPage = () => {
  return (
    <main data-testid="testimonial-page" className="pt-24 min-h-screen bg-[#0a0a0a]">
      <SEO 
        title="Client Testimonials - What Our Award Winners Say"
        description="Watch video testimonials from Golden Tree Events award winners and participants. Hear from CEOs, GMs, and industry leaders across 50+ countries about their award experience."
      />
      {/* Hero Section */}
      <section className="py-16 md:py-24 border-b border-white/10">
        <div className="w-full px-4 sm:px-8 lg:px-16">
          <div className="text-center">
            <p className="font-google-sans text-[#D4AF37] text-xs tracking-[0.3em] uppercase mb-4">Client Testimonials</p>
            <h1 className="font-montserrat text-4xl sm:text-5xl lg:text-6xl text-white mb-6">
              <span className="gradient-gold">Testimonials</span>
            </h1>
            <p className="font-google-sans text-[#A1A1AA] text-lg max-w-2xl mx-auto">
              Hear from the leaders and organizations we've had the privilege to work with.
            </p>
          </div>
        </div>
      </section>

      {/* Testimonials Sections */}
      <section className="py-16">
        <div className="w-full px-4 sm:px-8 lg:px-16">
          {/* 2025 Testimonials - YouTube */}
          <TestimonialSection 
            title="2025 Client Testimonials" 
            videos={testimonials2025} 
          />
          
          <TestimonialSection 
            title="2024 Client Testimonials" 
            videos={testimonials2024} 
          />
          
          <TestimonialSection 
            title="2023 Client Testimonials" 
            videos={testimonials2023} 
          />
          
          <TestimonialSection 
            title="International Travel / Spa / Dining / GM Awards 2023" 
            videos={testimonials2023Awards} 
          />
          
          <TestimonialSection 
            title="Arabian Best of Best Awards 2022" 
            videos={testimonials2022} 
          />
          
          <TestimonialSection 
            title="International Travel Awards 2021" 
            videos={testimonials2021} 
          />
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-[#D4AF37]">
        <div className="w-full px-4 sm:px-8 lg:px-16 text-center">
          <h2 className="font-montserrat text-black text-3xl sm:text-4xl mb-4">
            Nominate your Company / CEO / GM / Entrepreneur / Women Achievers Now
          </h2>
          <p className="font-google-sans text-black/70 mb-8">
            Join our community of award-winning organizations.
          </p>
          <a
            href="https://goldentreeawards.com/award-nomination"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="testimonial-nominate-cta"
            className="inline-flex items-center gap-3 bg-black text-white font-medium px-10 py-4 uppercase tracking-widest text-sm hover:bg-black/80 transition-all duration-300"
          >
            Nominate Now
            <ArrowRight className="w-4 h-4" />
          </a>
        </div>
      </section>
    </main>
  );
};

export default TestimonialPage;
